// The item route loads its pages before it opens, in every layout: in the sidebar layout too, where the address
// changes while the database page draws the item. Fetching that code ahead keeps the first item opened from waiting
// for a download. A failed fetch is left to the route itself, which loads the same files again when it opens.
function loadDatabaseItemPages() {
  import('@toolify/client/src/pages/StackableDatabaseItemPage/StackableDatabaseItemLayerPage.vue').catch(() => {})
  import('@toolify/client/src/pages/DatabaseItemPage/DatabaseItemPage.vue').catch(() => {})
}

export function prefetchDatabaseItemPages(): void {
  loadDatabaseItemPages()
}

// For a page an item may be opened from: the code comes once the browser has nothing else to do.
export function prefetchDatabaseItemPagesWhenIdle(): void {
  if(typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(loadDatabaseItemPages, {timeout: 5000})
    return
  }
  setTimeout(loadDatabaseItemPages, 2000)
}
